/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useEffect, useCallback } from 'react';
import { bindActionCreators } from 'redux';

import SidebarContainer from '../SidebarContainer';
import groupsActions from '../../redux/groups/actions';
import dealerActions from '../../redux/dealers/actions';

import { GroupEditor } from '../../components/GroupEditor';
import './Group.scss';

import ContentPage from '../ContentPage';
import ErrorMessage from '../../components/ErrorMessage';

function Group({
  actions,
  match,
  group = {},
  history,
  dealers,
  fetching,
  error,
}) {
  useEffect(() => {
    actions.dealersRequest();
  }, [actions, actions.dealersRequest]);

  const { groupId, tab, step: rawStep = 0 } = match.params;
  const step = Number(rawStep);

  useEffect(() => {
    actions.resetGroup();
    if (groupId) {
      actions.groupRequest({
        groupId,
      });
    }
  }, [actions, groupId]);

  const onSubmit = useCallback(
    async (params) => {
      const { id } = params || {};
      if (id) {
        actions.updateGroupRequest(params);
        return;
      }
      actions.createGroupRequest(params);
    },
    [actions],
  );

  return (
    <SidebarContainer
      title={group.name ? group.name : 'Create a Group'}
      openSubMenu="Client Management"
      logo={group?.logo}
    >
      <div className="groups-table">
        {error && <ErrorMessage error={error} />}
        <GroupEditor
          onSubmit={onSubmit}
          history={history}
          dealers={dealers}
          groupId={groupId}
          tab={tab}
          step={step}
          group={group}
          fetching={fetching}
        />
      </div>
    </SidebarContainer>
  );
}

Group.propTypes = {
  match: PropTypes.object,
  actions: PropTypes.object,
  group: PropTypes.object,
  history: PropTypes.object,
  dealers: PropTypes.array,
  fetching: PropTypes.bool,
};

const mapStateToProps = ({ dealers, feeds, user, groups }) => ({
  dealers: dealers.dealers,
  error: groups.error,
  feeds: feeds.feeds,
  user: user.currentUser,
  groups,
  group: groups?.group,
  fetching: groups?.fetching,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...groupsActions, ...dealerActions }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentPage(Group));
